import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { NavLink,Link} from 'react-router-dom';
import { history } from "../../../history/history";
import moment from "moment";
const HeaderAdminpanel = props => {
const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));   

 return (
        <div className="navbar-header dashboard-header clearfix">
          <div className="logo-dashboard">
            <div className="logodetaisls">
            <a id="logo">
              <img className="logo-trans" src="/assets/images/new_logo.png" />
            </a>
           {/* </div>           
            <div className="welcometext"> */} 
            <span className="supportlink" style={{ position:'relative', bottom:'38px', left:'17px', fontSize:12 }}><a style={{color:'white'}} target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSfEbCiG9bLYZvO1tK9Kczswnv7905Z9g1DHx09YjKIEkTYQOg/viewform">Support Portal</a> </span>         
            <span className="welcometext" style={{ position:'relative', bottom:'8px', right:'90px', color:'white', fontSize:12}}> Welcome: {adminInfo.email} </span>
            <span className="lastlogin" style={{ position:'relative', bottom:'8px', right:'72px', color:'white', fontSize:12 }}> Last Login @ {moment(adminInfo.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>
            </div>
          </div>
          <div>
          <div className="user-profile pull-right" tabIndex={0}
            onClick={() => { localStorage.removeItem("adminInfo");
              window.location.href = "/admin/login";
            }} >           
           <a>
           <div>
           <a><span>LOGOUT<span className="log_img"><img src="/assets/images/ic_logout.png" /></span></span></a>
           <span style={{color:"white", fontSize:12}}>V - Dev-2.15</span>
                </div>
            </a>
            </div>
        </div>
        </div>
  )
 }
export default HeaderAdminpanel;


// WEBPACK FOOTER //
// ./web/components/admin/common/HeaderAdminpanel.jsx